<template>
  <weui-msg type="warn" :primary="true" title="您删除的是一系列重复课程" desc="请作出以下进一步选择">
    <weui-button type="primary" @click="deleteCurrent">仅删除本节课</weui-button>
    <weui-button type="default" @click="deleteRemaining">同时删除本系列余下课程</weui-button>
    <weui-button type="default" @click="$router.go(-1)">返回上一页</weui-button>
  </weui-msg>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import weui from '@/wechat/weui';
import sleep from '@/utils/await-sleep';
import { WeuiButton, WeuiMsg } from '@/components/weui';
import dtos from '@/dtos/course';

import { ROUTE_CALENDAR } from '@/router/names';
import { FETCH_COURSE, DELETE_CURRENT_COURSE, DELETE_REMAINING_COURSES } from '@/store/course/types';

const { mapState, mapActions } = createNamespacedHelpers('course');

export default {
    data() {
        return {
            id: 0,
        };
    },
    computed: {
        ...mapState({
            course: state => state.course,
        }),
    },
    async created() {
        const { id } = this.$route.params;
        this.id = Number.parseInt(id, 10);

        await this.fetchCourse(this.id);

        if (!this.course || !dtos.periodic(this.course)) {
            this.$router.go(-1);
        }
    },
    methods: {
        ...mapActions({
            fetchCourse: FETCH_COURSE,
            deleteCurrentCourse: DELETE_CURRENT_COURSE,
            deleteRemainingCourses: DELETE_REMAINING_COURSES,
        }),
        async deleteCurrent() {
            if (!await weui.confirm('确认删除本节课吗？')) {
                return;
            }
            await this.deleteCurrentCourse({ id: this.id });
            weui.toast('删除成功');
            sleep(500);
            this.$router.replace({
                name: ROUTE_CALENDAR,
                query: {
                    date: this.course.date,
                },
            });
        },
        async deleteRemaining() {
            if (!await weui.confirm('确认删除本节课和同系列的余下课程吗？')) {
                return;
            }
            await this.deleteRemainingCourses({ id: this.id });
            weui.toast('删除成功');
            sleep(500);
            this.$router.replace({
                name: ROUTE_CALENDAR,
                query: {
                    date: this.course.date,
                },
            });
        },
    },
    components: {
        WeuiButton,
        WeuiMsg,
    },
};
</script>



// WEBPACK FOOTER //
// src/containers/course/Deleting.vue